// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../../../Config.bs.js";
import * as Js_dict from "../../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CrmNetwork from "../../../../../../../../library/network/CrmNetwork.bs.js";
import * as NetworkUtils from "../../../../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function successOrError(result) {
  if (typeof result === "number") {
    return {
            TAG: /* Error */1,
            _0: ErrorUtils$Catalyst.getDefaultErrorEntity("Failed to send invoice email", undefined, undefined)
          };
  }
  switch (result.TAG | 0) {
    case /* Success */0 :
    case /* SuccessWithNoContent */1 :
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
    default:
      return {
              TAG: /* Error */1,
              _0: ErrorUtils$Catalyst.getDefaultErrorEntity("Failed to send invoice email", undefined, undefined)
            };
  }
}

function sendViaCrmGateway(orderId, emails, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/invoices/send-email";
  var payload = JSON.stringify(Js_dict.fromArray([
            [
              "order_id",
              orderId
            ],
            [
              "emails",
              Belt_Array.map(emails, (function (prim) {
                      return prim;
                    }))
            ]
          ]));
  return NetworkUtils.catchPromiseError(CrmNetwork.post(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country),
                    "Content-Type": "application/json"
                  }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
                  return Promise.resolve(successOrError(result));
                }), requestUrl);
}

function sendViaOms(orderCrn, emails, country) {
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/sendinvoice", Js_dict.fromArray([
            [
              "order_id",
              orderCrn
            ],
            [
              "email",
              emails.join(",")
            ]
          ]));
  return NetworkUtils.catchPromiseError(CrmNetwork.get(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return Promise.resolve(successOrError(result));
                }), requestUrl);
}

function sendInvoiceEmail(orderId, orderCrn, emails, country) {
  if (country.TAG === /* India */1) {
    return sendViaCrmGateway(orderId, emails, country);
  } else {
    return sendViaOms(orderCrn, emails, country);
  }
}

export {
  successOrError ,
  sendViaCrmGateway ,
  sendViaOms ,
  sendInvoiceEmail ,
  
}
/* Config Not a pure module */
